export default __webpack_public_path__ + "static/media/CHM_S_XLG.2d6bee26.png";